import { AddAssetCard } from '@/components/Cards/AddAssetCard';
import { CreateAvatarModal } from '@/pages/avatar';
import { Presenter } from '@d-id/types';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';

const StyledAddAssetCard = styled(AddAssetCard)`
    height: 100%;
    background-color: white;
`;

const TriggerContainer = styled.div`
    background: ${({ theme }) => theme.colors.white};

    cursor: pointer;

    border-radius: 8px;
    border: ${({ theme }) => `1px solid ${theme.colors.black[300]};`};
    overflow: hidden;

    :hover {
        border: ${({ theme }) => `1px solid ${theme.colors.secondary[900]};`};
    }
`;

interface Props {
    isLoading: boolean;
    onUploadClick: (avatar: Presenter | undefined) => void;
    onAvatarUpload: (avatar?: Presenter) => void;
    label: 'Create Avatar' | 'Upload Avatar';
}

export const AddAvatarCard = observer(({ isLoading, onUploadClick, onAvatarUpload, label }: Props) => {
    return (
        <>
            <TriggerContainer>
                <StyledAddAssetCard loading={isLoading} onClick={onUploadClick} label={label} testId="add-avatar-button" />
            </TriggerContainer>
            <CreateAvatarModal from="editor" onUpload={onAvatarUpload} />
        </>
    );
});
